import { Api } from "../config/request";

export default {
  getChatDepartments(payload) {
    return Api.post("/logistics-support/chat-departments", payload);
  },
  getChatDepartmentById(id) {
    console.log("calling", id);
    return Api.get(`/logistics-support/chat-department/${id}`);
  },
  upsertChatDepartment(payload) {
    return Api.put(`/logistics-support/upsert-chat-department`, payload);
  },
};
